import DeliveryMethodType from "../types/DeliveryMethodType";

export default interface IAppointmentType {
	minimumDuration: number;
	appointmentTypeName: string;
	description: string;
	appointmentTypeId: number;
	preDepositAmount: number;
	disabled: boolean;
	organisationId: number;
	deliveryMethod: DeliveryMethodType;
	displayOrder: number;
	category: string;
	photoUri: string;
}

export const InitialAppointmentTypeState: IAppointmentType = {
	appointmentTypeId: 0,
	appointmentTypeName: "",
	minimumDuration: 0,
	description: "",
	preDepositAmount: 0,
	disabled: true,
	organisationId: 1,
	deliveryMethod: 2,
	displayOrder: 0,
	category: "none",
	photoUri: "",
};
